module.exports = __webpack_public_path__ + "d9354fd8451a7ad13e0e81ac47abc5cd.png";